import {environmentConfig} from "@/config/enviromentConfig";
import axios from "axios";

export default class UtilsService {
  static async fetchNumberCarrier(msisdn) {
    try {
      const response = await axios.post(`${environmentConfig.utilsService}/check-carrier`, {
        msisdn
      }, {
        timeout: 10000
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching carrier:', error);
      throw new Error('Failed to fetch carrier information');
    }
  }
}